<template>
	<ProcessCreatePage>
		<Header :title="title">
			<div class="flex flex-wrap">
				<p>
					{{ $t('choose_lawyers_office') }}
				</p>
			</div>
		</Header>

		<div class="main flex w-full justify-between">
			<div :class="['flex flex-wrap text-left grid gap-x-8 m-auto', premiumLawyerOfficeOptions.length > 0 ? 'grid-cols-3' : 'grid-cols-2']">
				<div>
					<h5 class="text-lg font-semibold text-green-500 mb-1">{{ $t('advantage_system_partner_input') }}</h5>
					<p>
						{{ $t('lawyer_system_partner_description') }}
					</p>
				</div>

				<div v-if="premiumLawyerOfficeOptions.length > 0">
					<h5 class="text-lg font-semibold text-yellow-500 mb-1">{{ $t('advantage_premium_partner_input') }}</h5>
					<p>
						{{ $t('lawyer_premium_partner_description') }}
					</p>
				</div>

				<div>
					<h5 class="text-lg font-semibold text-red-500 mb-1">{{ $t('disadvantage_foreign_lawyer_input') }}</h5>
					<p>
						{{ $t('foreign_lawyer_description') }}
					</p>
				</div>

				<div>
					<BaseRadioForm
						ref="BaseRadioForm"
						:options="lawyerOfficeOptions"
						v-model="lawyerOffice"
						:label="$t('lawyer')"
						:allow-empty="!isUserAllowedInLevel5or6"
					/>
				</div>

				<div v-if="premiumLawyerOfficeOptions.length > 0">
					<BaseRadioForm
						ref="BaseRadioForm"
						:options="premiumLawyerOfficeOptions"
						v-model="lawyerOffice"
						:label="$t('lawyer')"
						:allow-empty="!isUserAllowedInLevel5or6"
					/>
				</div>

				<div>
					<BaseRadioForm
						ref="BaseRadioFormForeign"
						:options="foreignLawyerOfficeOptions"
						v-model="lawyerOffice"
						class="mt-8"
						:allow-empty="!isUserAllowedInLevel5or6"
					/>
				</div>
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="isSkippable"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import Authentication from '@/mixins/Authentication';
import BaseRadioForm from '@/components/forms/inputs/BaseRadioForm';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import LawyerOfficeRepository from '@/api/repositories/LawyerOfficeRepository';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'LawyerAuthority',
	components: { ProcessCreatePage, BaseRadioForm, Header, Footer },
	mixins: [Authentication],
	props: {
		title: {
			default: function() {
				return this.$t('new_damage_case_lawyers_office');
			},
		},
		isSkippable: { default: true },
	},
	computed: {
		foreignLawyerOfficeOptions() {
			return [
				{
					display: this.$t('customers_lawyer'),
					value: {
						id: null,
						city: {},
					},
				},
			];
		},
	},
	data() {
		return {
			lawyerOffice: {},
			lawyerOfficeOptions: [],
			premiumLawyerOfficeOptions: [],
		};
	},
	mounted() {
		this.getLawyersOffices();
		this.getPremiumLawyerOffices();
	},
	methods: {
		getLawyersOffices() {
			let promise;
			if (this.isUserAllowedInLevel5or6) {
				promise = RepairShopRepository.lawyersOffices(RepairShopRepository.repairShopId).then(response => response.data.data);
			} else {
				promise = LawyerOfficeRepository.index({ partner_type: 'system_partner' }).then(response => response.data);
			}

			promise.then(response => {
				this.lawyerOfficeOptions = response.map(option => {
					let address = '';
					if (option.street != null) {
						address = option.street + (option.houseNumber !== undefined ? ' ' + option.houseNumber : '');
					} else {
						address = this.$t('po_box') + ' ' + option.poBox;
					}

					return {
						display: `${option.name} <br/>${address}, ${option.city.zipCode ?? ''} ${option.city.name ?? ''}<br/> ${option.email} <br/>${
							option.phoneNumber
						}`,
						value: option,
					};
				});
				this.lawyerOffice = this.lawyerOfficeOptions[0]?.value;
			});
		},
		getPremiumLawyerOffices() {
			let promise;
			if (this.isUserAllowedInLevel5or6) {
				promise = RepairShopRepository.premiumLawyersOffices(RepairShopRepository.repairShopId).then(response => response.data.data);
			} else {
				promise = LawyerOfficeRepository.index({ partner_type: 'premium_partner' }).then(response => response.data);
			}

			promise.then(response => {
				this.premiumLawyerOfficeOptions = response.map(option => {
					let address = '';
					if (option.street != null) {
						address = option.street + (option.houseNumber !== undefined ? ' ' + option.houseNumber : '');
					} else {
						address = this.$t('po_box') + ' ' + option.poBox;
					}
					return {
						display: `${option.name} <br/>${address}, ${option.city.zipCode ?? ''} ${option.city.name ?? ''}<br/> ${option.email} <br/>${
							option.phoneNumber
						}`,
						value: option,
					};
				});
			});
		},
		continueButtonClick(isSkip) {
			if (isSkip) {
				this.$emit('skipLawyerOffice', true);
				this.$emit('next', null);
			} else if (this.lawyerOffice) {
				this.$emit('skipLawyerOffice', false);
				this.$emit('clearLawyerOffice');
				this.$emit('next', { lawyerOffice: this.lawyerOffice });
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
